// @flow
import type { Error, Errors } from 'types/errors';

import React from 'react';

type Props = {
  errors: Errors,
  dismissible: boolean,
  onClose: Function,
};

/* eslint-disable react/no-array-index-key */
export default function ErrorNotification(props: Props) {
  return (
    <div
      className="notification is-danger"
      role="alert"
    >
      {props.dismissible &&
        <button
          className="delete"
          aria-label="Close"
          onClick={() => props.onClose && props.onClose()}
        />
      }
      {props.errors.map((error: Error, i) => (
        <p key={i}>{error.message}</p>
        ))}
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/js/components/others/ErrorNotification.jsx
 **/